import { Box, Slider, Typography } from '@mui/material';
import React from 'react';
import { HormoneSnapshot, ResultType } from '../../../types';
import { colors } from '../../../utils/theme';

const marks = [
  {
    value: 8,
    label: 'OPTIMAL',
  },
  {
    value: 32,
    label: 'ALARMED',
  },
  {
    value: 60,
    label: 'IMBALANCED',
  },
  {
    value: 90,
    label: 'EXHAUSTED',
  },
];

const snapshotResultToValue: Record<ResultType, number> = {
  normal: 8,
  type_1: 32,
  type_2: 60,
  type_3: 90,
};

export const StressArchetypeSlider = ({
  snapShot,
}: {
  snapShot: HormoneSnapshot;
}): JSX.Element => {
  const value = snapShot?.result
    ? snapshotResultToValue[snapShot?.result as ResultType]
    : marks[0].value;

  return (
    <Box sx={{ width: '100%' }}>
      <Slider
        value={value}
        aria-labelledby="discrete-slider"
        valueLabelDisplay="auto"
        marks={marks.map((mark) => ({
          ...mark,
          label: (
            <Typography
              fontSize={12}
              variant={mark.value === value ? 'medium' : 'light'}
              sx={{
                opacity: mark.value === value ? 1 : 0.8,
                color: colors.greys.TEXT_BLACK,
              }}
            >
              {mark.label}
            </Typography>
          ),
        }))}
        disabled
        sx={{
          color: 'transparent',
          height: 20,
          borderRadius: 1.25,
          '& .MuiSlider-rail': {
            background:
              'linear-gradient(90deg, #2AD033 0%, #FFD233 48.44%, #EF562B 100%)',
            height: 20,
            opacity: 1,
          },
          '& .MuiSlider-track': {
            background: 'transparent',
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            '&:before': {
              content: '""',
              display: 'block',
              position: 'relative',
              borderRadius: '50%',
              backgroundColor: colors.greys.BASE_WHITE,
              height: 12,
              width: 12,
              zIndex: 1,
              border: `1px solid ${colors.greys.BRAND_BLACK}`,
            },
          },
          '& .MuiSlider-markLabel': {
            marginTop: 1,
          },
          '& .Mui-disabled': {
            color: 'transparent !important',
            cursor: 'none',
          },
          '& .MuiSlider-mark': {
            backgroundColor: 'transparent',
          },
          '& .MuiSlider-markActive': {
            backgroundColor: 'transparent',
            fontWeight: 300,
            color: colors.greys.TEXT_BLACK,
          },
        }}
      />
    </Box>
  );
};
